import React from 'react'
import ImageWrap from 'components/ImageWrap'
import PageLink from 'components/PageLink'
import { strings } from 'js/strings'

export default function Banner({ content, template }) {
  let isRecenter,
    isSmallerTitle,
    isSmallerDescription,
    isIconRight,
    isHome,
    isCareers = false
  if (['Industries', 'Solutions', 'Insights'].includes(template)) {
    isRecenter = true
  }
  if (['Platform', 'Platform Single'].includes(template)) {
    isSmallerTitle = true
  }
  if (['Home', 'Industries', 'bannerMid', 'Resource 2'].includes(template)) {
    isSmallerDescription = true
  }
  if (['Resource 2'].includes(template)) {
    isIconRight = true
  }
  if (['Home'].includes(template)) {
    isHome = true
  }
  if (['Careers'].includes(template)) {
    isCareers = true
  }
  const { image, icon, chart, title, description, buttons, isInverseTemplate } =
    content
  const recenterClass = isRecenter ? 'hero--recenter' : ''
  const isInverseClass = isInverseTemplate ? 'is-inverse' : ''
  const iconRightClass = isIconRight ? 'icon-right' : ''
  const isHomeClass = isHome ? 'is-home' : ''
  return (
    <section
      className={`multivariate-grid multivariate-grid--horizontal-clip hero ${recenterClass} ${isInverseClass} ${iconRightClass} ${isHomeClass}`}
    >
      <section className='image'>
        {image.desktop && (
          <ImageWrap className='desktop-only' image={image.desktop} />
        )}
        {image.mobile && (
          <ImageWrap className='mobile-only' image={image.mobile} />
        )}
      </section>

      <div className='hero__container multivariate-grid__container'>
        <div className='hero__inner-container'>
          <div className='wrap'>
            <div className='hero__icon'>
              {chart && isHome && (
                <div className='figure figure-chart'>
                  <ImageWrap image={chart} />
                </div>
              )}
              <div className='figure figure-icon'>
                <ImageWrap image={icon} />
              </div>
            </div>
            <div className='hero__text'>
              {title && (
                <>
                  {!isSmallerTitle && (
                    <h1
                      className='hero__title hero__title-tag-h1'
                      dangerouslySetInnerHTML={{ __html: title }}
                    />
                  )}
                  {isSmallerTitle && (
                    <h2
                      className='hero__title hero__title-tag-h2'
                      dangerouslySetInnerHTML={{ __html: title }}
                    />
                  )}
                </>
              )}
              {description && (
                <div className='hero__excerpt'>
                  {!isSmallerDescription && (
                    <h4>
                      <span>{description}</span>
                    </h4>
                  )}
                  {isSmallerDescription && (
                    <p>
                      <span>{description}</span>
                    </p>
                  )}
                </div>
              )}
              {buttons && <Buttons buttons={buttons} />}
              {isCareers && (
                <div className='hero__cta-list hero__cta-list--1'>
                  <a
                    href='https://jobs.lever.co/analyticpartners'
                    target='_blank'
                    className='hero__cta'
                  >
                    {strings.viewOpenPositions}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const Buttons = ({ buttons, isAlt = false }) => {
  const isAltClass = isAlt ? 'hero__inner-container alt-buttons' : ''
  return (
    <div
      className={`hero__cta-list hero__cta-list--${buttons.length} ${isAltClass}`}
    >
      {buttons.map((button, i) => {
        const { pageLink, pageLinkText } = button
        return (
          <PageLink key={i} pageLink={pageLink} className='hero__cta'>
            {pageLinkText}
          </PageLink>
        )
      })}
    </div>
  )
}
